import { Icon, IconProps } from '@chakra-ui/react'

export default function AbsentPatientIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#323232'}
      {...props}
    >
      <path
        d="M8 10.6672H6.328C5.824 10.6672 5.33866 10.8579 4.96866 11.1999L4.926 11.2399C4.69133 11.4572 4.50866 11.7239 4.39 12.0212L4.15666 12.6072"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.79066 8.7907C9.68733 8.46736 10.3333 7.62336 10.3333 6.61403C10.3333 5.32536 9.28866 4.28003 7.99933 4.28003C6.99 4.28003 6.146 4.92603 5.82266 5.82336"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.64 5.30737C1.51 7.55671 1.87934 10.3667 3.75667 12.244C5.63467 14.122 8.44534 14.4907 10.6947 13.36"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.756 3.75678V3.75678C6.1 1.41278 9.9 1.41278 12.2433 3.75678C14.5867 6.10011 14.5867 9.89944 12.244 12.2434"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 13.3334L2.66666 2.66675"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
